module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "post-detail"
  }, [_c('div', {
    class: _vm.wrapBackground,
    attrs: {
      "id": "wrap"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "loading-msg link-ellipsis"
  }, [_vm._v("\n      正在載入網址："), _c('a', {
    attrs: {
      "href": _vm.post.iframe,
      "target": "_blank",
      "alt": _vm.post.iframe
    }
  }, [_vm._v(_vm._s(_vm.post.iframe || 'N/A') + " ")])]) : _c('div', {
    staticClass: "loading-msg link-ellipsis"
  }, [_vm._v("\n      共編/作品網址："), _c('a', {
    attrs: {
      "href": _vm.post.iframe,
      "target": "_blank",
      "alt": _vm.post.iframe
    }
  }, [_vm._v(_vm._s(_vm.post.iframe || '未填寫') + " ")])]), _vm._v(" "), (_vm.loadIframe) ? _c('iframe', {
    attrs: {
      "id": "iframe",
      "src": _vm.src,
      "frameborder": "1"
    },
    on: {
      "load": function($event) {
        _vm.isLoading = false
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.msg))])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    attrs: {
      "id": "info"
    }
  }, [_c('div', {
    attrs: {
      "id": "header"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.post.name))]), _vm._v(" "), _c('h3', [_c('icon', {
    staticClass: "fa-icon-pointer",
    attrs: {
      "name": (_vm.isLovedByMe ? 'heart' : 'heart-o')
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleHeart($event)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.heartCount))])], 1), _vm._v(" "), _c('h3', [_c('icon', {
    staticClass: "fa-icon-pointer",
    attrs: {
      "name": (_vm.isStaredByMe ? 'star' : 'star-o')
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleStar($event)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.starCount))])], 1), _vm._v(" "), _c('h3', [_c('icon', {
    staticClass: "fa-icon-pointer",
    attrs: {
      "id": "location",
      "name": "map-o"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.goMap(_vm.post.table)
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.post.table ? _vm.post.table + '桌' : '未選桌號'))])], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    attrs: {
      "id": "desc-block"
    }
  }, [_vm._l((_vm.post.tags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "type": "gray",
        "color": "white"
      }
    }, [_vm._v(_vm._s(tag))])
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.post.desc))])], 2), _vm._v(" "), _c('span', {
    attrs: {
      "id": "gutter"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "link-ellipsis",
    attrs: {
      "id": "ul-block"
    }
  }, [_c('b', [_c('li', [_vm._v("提案者：" + _vm._s(_vm.post.host))])]), _vm._v(" "), _c('b', [_c('li', [_vm._v("參與者： "), _vm._l((_vm.post.teammates), function(t) {
    return _c('span', [_vm._v(_vm._s(t) + ", ")])
  })], 2)]), _vm._v(" "), _c('li', [_vm._v("專案狀態：" + _vm._s(_vm.post.status))]), _vm._v(" "), _c('li', [_vm._v("\n          專案介紹 URL: "), _c('a', {
    attrs: {
      "href": _vm.post.iframe,
      "target": "_blank",
      "alt": _vm.post.iframe
    }
  }, [_vm._v(_vm._s(_vm.post.iframe || '未填寫'))])]), _vm._v(" "), _c('li', [_vm._v("\n          GitHub: "), (_vm.post.git) ? _c('a', {
    attrs: {
      "href": 'https://github.com/' + _vm.post.git,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.post.git))]) : _c('span', [_vm._v("未填寫")])]), _vm._v(" "), _c('li', [_vm._v("聯絡方式：" + _vm._s(_vm.post.contact || '無'))]), _vm._v(" "), _c('li', [_vm._v("企業獎調查：" + _vm._s((_vm.post.awards ? ("1." + (_vm.post.awards[0]) + "  2." + (_vm.post.awards[1] || '無')) : '無')))]), _vm._v(" "), _c('li', [_vm._v("最近更新："), _c('time', [_vm._v(_vm._s(new Date(_vm.post.timestamp).toLocaleString()))])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08ea9e06"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/hackingmap/postdetail.vue
// module id = 959
// module chunks = 1